module.exports = __webpack_public_path__ + "img/rancher-logo.07b3b404.svg";